import React from 'react';
import { ChartIcon } from '@/components/DesignSystem/Icons';
import { DataBoxProps } from '../types';

const DataBox: React.FC<DataBoxProps> = ({
  label,
  value,
  icon,
  className = '',
}) => {
  return (
    <div
      className={`not-prose border border-gray-200 rounded-lg p-4 shadow-sm  w-full ${className}`}
    >
      <div className='flex flex-col'>
        {icon || <ChartIcon />}
        <div className='flex-1'>
          <div className='text-sm md:text-base text-gray-600 mb-1'>{label}</div>
          <div className='text-base md:text-2xl font-bold text-black'>
            {value}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataBox;
